/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFNameItem
 */
export interface CRSFNameItem {
    /**
     * 
     * @type {string}
     * @memberof CRSFNameItem
     */
    Email: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFNameItem
     */
    Name: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFNameItem
     */
    Type: number;
}

/**
 * Check if a given object implements the CRSFNameItem interface.
 */
export function instanceOfCRSFNameItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "Email" in value;
    isInstance = isInstance && "Name" in value;
    isInstance = isInstance && "Type" in value;

    return isInstance;
}

export function CRSFNameItemFromJSON(json: any): CRSFNameItem {
    return CRSFNameItemFromJSONTyped(json, false);
}

export function CRSFNameItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFNameItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'Email': json['Email'],
        'Name': json['Name'],
        'Type': json['Type'],
    };
}

export function CRSFNameItemToJSON(value?: CRSFNameItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Email': value.Email,
        'Name': value.Name,
        'Type': value.Type,
    };
}

